module.exports = __webpack_public_path__ + "static/media/new_tag_mapless.6b0c24e8.gif";